import { AfterViewInit, Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { initFlowbite, Modal, ModalOptions } from "flowbite";
import { filter, map, mergeMap, Subscription, tap } from "rxjs";
import { environment } from "../environments/environment";
import { HttpClient } from "@angular/common/http";
import { DOCUMENT } from "@angular/common";
import { DomSanitizer, Meta, SafeStyle, Title } from "@angular/platform-browser";
import { ConfigService } from "./common/service/config.service";
import { BrowserValidatorService } from "./common/service/browser-validator.service";
import { ContentBlockComponent } from "./component/content-block/content-block.component";
import Bowser from "bowser";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [ RouterOutlet, ContentBlockComponent ],
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('modal') modal!: ElementRef;

  public pageBackgroundUrl: SafeStyle | undefined;
  public isMobile: boolean = false;
  public isBooth: boolean = false;

  private subscription: Subscription | undefined;
  private slug: string | undefined;
  private config: any;

  private modalInstance: Modal | undefined;
  private browser: Bowser.Parser.Parser;

  constructor(
    private router: Router,
    private httpClient: HttpClient,
    private route: ActivatedRoute,
    @Inject(DOCUMENT) private document: Document,
    @Inject('Window') private window: Window,
    @Inject('Storage') protected storage: Storage,
    private titleService: Title,
    private metaService: Meta,
    private configService: ConfigService,
    private sanitizer: DomSanitizer,
    private browserValidator: BrowserValidatorService
  ) {
    this.browser = Bowser.getParser(this.window.navigator.userAgent);
    this.isMobile = this.browser.getPlatformType(true) === 'mobile';

  }

  ngOnInit(): void {

    // @ts-ignore
    this.document.getElementById("preloader").style.display = "none";

    initFlowbite();

    // @ts-ignore
    const slug = this.document.slug;

    this.subscription = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map((event) => this.rootRoute(this.route)),
      filter((route: ActivatedRoute) => route.outlet === 'primary'),
      map(route => slug || route?.snapshot?.params['slug']),
      tap((s) => this.slug = s),
      mergeMap((s) => this.httpClient.get<any>(environment.assets_url + environment.env + '/manifests/' + s + '/app.json?_=' + new Date().getTime() + Math.random().toString().slice(2, 8).replace(/\./g, ''))),
    ).subscribe({
      next:(config:any) => {

        this.route.queryParams.subscribe((params) => {
          if(params && Object.keys(params).length > 0) {
            this.storage.setItem('utm_params', JSON.stringify(params));
          }
        });

        this.isBooth = this.storage.getItem('forceBoothMode') === 'true';
        this.loadCss();
        this.config = config;
        const screenRatio = this.window.screen.width / this.window.screen.height;
        console.log('screenRatio', screenRatio);
        config.screenRatio = screenRatio;
        this.configService.notify(config);
        this.titleService.setTitle(config.name);
        this.metaService.updateTag({'name': 'apple-mobile-web-app-title', content: config.name});

        if(config.pageBackgroundUrl) {
          this.pageBackgroundUrl = this.sanitizer.bypassSecurityTrustStyle('url(' + config.pageBackgroundUrl + ')');
        }

      },
      error: console.error
    });
  }

  ngAfterViewInit(): void {
    const browserWarningDismissed = this.storage.getItem('browserWarningDismissed');
    if (this.modal && ! browserWarningDismissed) {
      // @ts-ignore
      if ( ! this.browserValidator.isValid() || (navigator.brave && navigator.brave.isBrave() || false)) {
        this.showBrowserCompatibilityWarning();
      }
    }
  }



  private loadCss() {
    const exiting = this.document.getElementById('css-styling');
    if ( ! exiting) {
      const head = this.document.getElementsByTagName('head')[0];
      const style = this.document.createElement('link');
      style.id = 'css-styling';
      style.rel = 'stylesheet';
      style.href = environment.assets_url + environment.env + '/manifests/' + this.slug + '/styles.css?_=' + new Date().getTime() + Math.random().toString().slice(2, 8).replace(/\./g, '');
      head.appendChild(style);
    }
  }

  ngOnDestroy(): void {
    if(this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private rootRoute(route: ActivatedRoute): ActivatedRoute {
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route;
  }

  private showBrowserCompatibilityWarning() {
    const options: ModalOptions = {
      placement: 'bottom-right',
      backdrop: 'dynamic',
      backdropClasses: 'bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40',
      closable: true
    };

    this.modalInstance = new Modal(this.modal.nativeElement, options);

    this.modalInstance.show();

    return false;
  }

  dismiss() {
    if(this.modalInstance) {
      this.modalInstance.hide();
      this.storage.setItem('browserWarningDismissed', '1');
    }
  }
}
